/**
 * @file withExitAnimation.tsx
 *
 * @fileoverview Component wrapper that ensures component's exit animation.
 */

import { AnimatePresence } from "framer-motion";
import { ReactNode } from "react";

export function withExitAnimation(Component: ReactNode, show: boolean) {
  return <AnimatePresence>{show && Component}</AnimatePresence>;
}
